import React, { useEffect, useState } from "react";
// import "./AuditionRounds.css";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Banner from "../../../../assets/images/BannerAuditionAdmin.png";
import ReactPlayer from "react-player";
import Slider from "react-slick";
import moment from "moment";
import noImage from "../../../../assets/images/settings/no-image.png";
import { Tab, Table, Nav } from "react-bootstrap";
import swal from "sweetalert";
import { Markup } from "interweave";
import ReUseableSingleRoundTab from "../../../Reuseable/ReUseableSingleRoundTab";
import AuditionApproveFilterVideo from "../../../AuditionAdmin/AuditonRounds/AuditionApproveFilterVideo";
import JuryMarkedTable from "./JuryMarkedTable";
import { serverInfo } from "../../../../App";
import { useContext } from "react";
import LoaderPost from "../../../Reuseable/LoaderPost";

const SingleLiveAuditionVideoAssessment = ({
  currentSlide,
  slideCount,
  ...props
}) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const { slug } = useParams();
  const [videoType, setVideoType] = useState("general");
  const [myGroup, setMyGroup] = useState(null);

  const [loading, setLoading] = useState(true);
  const [markAssignLoading, setMarkAssignLoading] = useState(false);
  const [activeRound, setActiveRound] = React.useState(0);
  const [event, setEvent] = useState({});
  const [auditionRoundInfo, setAuditionRoundInfo] = useState({});
  const [rounds, setRounds] = useState([]);

  const [eventVideos, setEventVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState({});
  const [allMarkedVideo, setAllMarkedVideo] = useState([]);

  const [mark, setMark] = useState("");

  const approvalWithMarkHandler = () => {
    if (
      selectedVideo.id === "" ||
      selectedVideo.id < 1 ||
      selectedVideo.id === undefined
    ) {
      swal("Warning", "Please Select a video first", "warning");
    } else if (mark === "" || mark < 1 || mark > 100) {
      swal("Warning", "Mark  Required & Should not more then 100", "warning");
    } else {
      const fData = new FormData();
      setMarkAssignLoading(true);
      fData.append("mark", mark);
      fData.append("video_id", selectedVideo?.id);
      fData.append("my_group", myGroup);

      axios.post(`/api/jury/audition/mark-assessment`, fData).then((res) => {
        setMarkAssignLoading(false);
        if (res.data.status === 200) {
          setMark(0);
          swal("Success", res.data.message, "success");
          getRoundAndFilterableVideos();
        }
      });
    }
  };

  const handleKeyPress = (e) => {
   
    if (e.key === "Enter") {
    
      if (selectedVideo?.id && mark) {
        approvalWithMarkHandler();
      }
    }
  };

  useEffect(() => {
    
    window.addEventListener("keypress", handleKeyPress);

    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, [selectedVideo, mark]);


  const handleSelectedVideo = (event) => {
    setSelectedVideo(event);
  };

  const handleAppealedVideos = () => {
    setVideoType("appeal");
  };

  const handleGeneralVideos = () => {
    setVideoType("general");
  };

  const getRoundAndFilterableVideos = (page = 1) => {
    axios
      .get(
        `/api/jury/audition/singleAuditionVideoAssessmentWithRound/${event?.id}/${activeRound}/${videoType}?page=${page}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          setEvent(res.data.audition);
          setMyGroup(res.data.myGroup);
          setAuditionRoundInfo(res.data.auditionRoundInfo);
          setEventVideos(res.data.auditionUploadVideos);
          setAllMarkedVideo(res.data.markedVideos);
        }

        setLoading(false);
      });
  };

  const fetchAuditionDetails = () => {
    axios.get(`/api/jury/audition/${slug}`).then((res) => {
      if (res.data.status === 200) {
        setEvent(res.data?.event);
        setActiveRound(res.data?.event?.active_round_info_id);
        setRounds(res.data.event?.audition_round);
      }
      setLoading(false);
    });
  };
  useEffect(() => {
    fetchAuditionDetails();
  }, [slug]);

  useEffect(() => {
    if (activeRound) {
      getRoundAndFilterableVideos();
    }
  }, [activeRound]);
  useEffect(() => {
    if (videoType) {
      getRoundAndFilterableVideos();
    }
  }, [videoType]);


  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <div className="container-lg">
          <div>
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey={activeRound}
            >
              <div className="container-lg">
                <Nav variant="pills">
                  <div className="row">
                    {rounds &&
                      rounds.map((auditionRound, index) => (
                        <ReUseableSingleRoundTab
                          key={index}
                          auditionRound={auditionRound}
                          setActiveRound={setActiveRound}
                        />
                      ))}
                  </div>
                </Nav>
                <div className="my-4"></div>
              </div>
            </Tab.Container>
          </div>

          <div className="card card-bg p-3 ">
            <img
              style={{ height: "400px" }}
              src={event?.banner ? imageCdnUrl + event?.banner : Banner}
              className="img-fluid border-warning rounded-3  w-100"
              alt=""
            />
            <h5 className="BannerPs">
              Round {auditionRoundInfo?.round_num} time duration
              {moment(auditionRoundInfo?.round_start_date).format("LL")} -
              {moment(auditionRoundInfo?.round_end_date).format("LL")}
            </h5>
          </div>

          <div className="my-3">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Nav variant="pills" className="d-flex justify-content-center">
                <div className="col-md-md-6 small-live-session mb-3">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="first"
                      className="TabCardGold d-flex  text-decoration-none text-center me-2 fw-bold pt-3 "
                      onClick={handleGeneralVideos}
                    >
                      <h5 className="font-style fw-bold">General Videos</h5>
                    </Nav.Link>
                  </Nav.Item>
                </div>
                <div className="col-md-md-6 small-live-session">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="second"
                      className="TabCardGold py-2 fw-bold pt-3 text-decoration-none text-center "
                      onClick={handleAppealedVideos}
                    >
                      <h5 className="font-style fw-bold">Appealed Videos</h5>
                    </Nav.Link>
                  </Nav.Item>
                </div>
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="first"></Tab.Pane>

                <Tab.Pane eventKey="second"></Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>

          <div className="row mt-3 me-2">
            <div className="card card-bg head-line mt-2 mb-2">
              <div className="text-light">
                <h4 className="mx-3 text-white fw-bolder text-center p-2">
                  All User Videos({eventVideos.total})
                </h4>
              </div>
            </div>

            <div className="my-3 row ">
              <AuditionApproveFilterVideo
                data={eventVideos}
                handleSelectedVideo={handleSelectedVideo}
                selectedVideo={selectedVideo}
                handlePageChange={getRoundAndFilterableVideos}
              />
            </div>
            <div className="py-4 row">
              <div className="col-md-6 d-flex mx-auto">
                <div className="col-md-2">
                  <h5 className="text-light">Mark:</h5>
                </div>

                <div className="col-md-7">
                  <input
                    type="number"
                    className="form-control reply-control text-black"
                    placeholder="Provide Your Marks"
                    value={mark}
                    onChange={(e) => setMark(e.target.value)}
                  />
                </div>

                <div className="col-md-4 px-1 d-flex justify-content-end">
                  {markAssignLoading ? (
                    <button
                      className="btn btnCreate fw-bold w-75"
                      type="submit"
                    >
                      loading...
                    </button>
                  ) : (
                    <button
                      disabled={markAssignLoading}
                      type="button"
                      className="btn btnCreate fw-bold w-75"
                      onClick={approvalWithMarkHandler}
                    >
                      Submit
                    </button>
                  )}
                </div>
              </div>
            </div>

            <hr
              style={{
                color: "white",
                backgroundColor: "white",
                height: 2,
                borderColor: "white",
              }}
            />

            <div className="my-3">
              <div className="card card-bg head-line mt-2 mb-2">
                <div className="text-light">
                  <h4
                    style={{ color: "rgb(253 224 71)" }}
                    className="mx-3 fw-bolder text-center p-2"
                  >
                    Marked Videos ({allMarkedVideo && allMarkedVideo.length})
                  </h4>
                </div>
              </div>

              <div className="">
                <JuryMarkedTable data={allMarkedVideo} myGroup={myGroup} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SingleLiveAuditionVideoAssessment;
